import { io, Socket } from "socket.io-client";
import { getToken, removeToken } from "src/helpers/helperFunctions";
import { Dispatch } from "@reduxjs/toolkit";
import SimplePeer from "simple-peer"; // WebRTC peer connection library
import { setCallNotifications } from "src/Store/VideoCall";
import { pushNewMessage, useStatusToogle } from "src/Store/chat";
import { IChatItem } from "src/types/GlobalInterfaces";
import { counterIncreament, removeAuth } from "src/Store/reducer";
import { store } from "src/Store/store";
import { removeAllIndicators, updateIndicators } from "src/Store/redDots";
import { toast } from "react-toastify";

const SOCKET_URL = process.env.REACT_APP_BACKEND_URL || ""; // server url
let socket: Socket | null = null;
let peer: SimplePeer.Instance | null = null; // WebRTC peer instance

// Function to initialize the socket connection
const initializeSocket = (dispatch: Dispatch) => {
  return new Promise<void>((resolve, reject) => {
    if (socket) {
      return resolve(); // Socket is already initialized
    }
    socket = io(SOCKET_URL, {
      autoConnect: false,
      auth: {
        token: getToken(),
      },
      transports: ["websocket", "polling"],
      pingInterval: 25000, // how often to ping (in milliseconds).
      pingTimeout: 60000, // time after which the connection is considered timed-out (in milliseconds).
    } as any); // socket dashboard

    // Add event listeners for socket connection
    socket.on("connect", () => {
      // console.log("SOCKET_URL", SOCKET_URL);
      resolve();
    });

    // Add event listeners for customerCall
    socket.on("customerCall", (data: any) => {
      console.log("Received customer call", data);
      dispatch(setCallNotifications(data));
    });

    // user status online/offline
    socket.on(
      "userStatus",
      (data: { statusOnline: boolean; userId: string }) => {
        dispatch(useStatusToogle(data));
      }
    );

    // user receive new message
    socket.on("receiveMessage", async (data: { document: IChatItem }) => {
      console.log("socket____receiveMessage", data);
      dispatch(pushNewMessage(data?.document));
      if (
        data?.document?.senderId === store.getState()?.chat?.selectedUser?._id
      ) {
        console.log("selectedUser_New_Message");
        await socket?.emit("chatOpened", {
          senderId: data?.document?.senderId,
          receiverId: store.getState()?.appReducer?.userDetails?._id,
        });
      }else{
        dispatch(counterIncreament("messageUnreadCount"));
      }
    });

    // 17/12/2024 red dots sockets
    socket.on("CUSTOMERS_INDICATORS", (data: any) => {
      console.log("CUSTOMERS_INDICATORS", data);
      dispatch(updateIndicators({ customers_indicators: true }));
    }); // for new customer generic indicators

    // socket.on("DOCTOR_INDICATORS", (data: any) => {
    //     console.log("DOCTOR_INDICATORS", data);
    //     dispatch(updateIndicators({ doctor_indicators: true }));
    // }); // for new doctor generic indicators

    socket.on("DOCTOR_REGISTERATION", (data: any) => {
      console.log("DOCTOR_REGISTERATION", data);
      dispatch(
        updateIndicators({
          newDoctorRegistered:
            (store.getState()?.redDots?.allIndicators?.newDoctorRegistered ||
              0) + 1,
        })
      );
    }); // for new doctor registration count

    socket.on("ADMIN_INDICATORS", (data: any) => {
      console.log("ADMIN_INDICATORS", data);
      dispatch(updateIndicators(data));
    }); // for admin side red dots
    socket.on("USER_INDICATORS", (data: any) => {
      console.log("USER_INDICATORS", data);
      dispatch(updateIndicators(data));
    }); // for all customer side red dots

    // 17/12/2024 red dots sockets

    // receive new notification
    socket.on("notification", (data: any) => {
      dispatch(counterIncreament("unreadNotificationCount"));
      console.log("notification", data);
    });

    socket.on("accountDeactivationByAdmin", (data: any) => {
      toast.success("Account deactivated by admin navigate to login page");
      dispatch(removeAuth());
      dispatch(removeAllIndicators());
      removeToken();
    });
    socket.on("emailChangeByAdmin", (data: any) => {
      toast.success("Email changed by the admin");
      dispatch(removeAuth());
      dispatch(removeAllIndicators());
      removeToken();
    });

    socket.on("disconnect", () => {
      console.log("disconnect socket");
    });

    // Connect the socket
    socket.connect();
  });
};

// Function to turn on the socket connection
const turnOnSocket = () => {
  if (socket) {
    // console.log("CONNECT SERVER");
    return Promise.all([socket.connect()]);
  } else {
    return Promise.reject(new Error("Socket is not initialized"));
  }
};

// Function to turn off the socket connection
const turnOffSocket = () => {
  // console.log("DISCONNECT SERVER");
  if (socket) {
    socket.disconnect();
  }
  if (peer) {
    peer.destroy(); // Close the WebRTC peer connection
    peer = null;
  }
};

export { initializeSocket, turnOnSocket, turnOffSocket , socket};
